export default __webpack_public_path__ + "static/media/DO.b1693778.png";